import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { featureFlagGuard } from './core/guards/feature-flag.guard';
import { Layout } from './core/layout/layout';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: Layout,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'license-series',
        loadChildren: () =>
          import('./features/license-series/license-series.routes').then(
            (m) => m.LICENSE_SERIES_ROUTES,
          ),
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./features/customers/customers.routes').then((m) => m.CUSTOMERS_ROUTES),
      },
      {
        path: 'admin',
        canActivate: [featureFlagGuard('administration'), roleGuard('admin')],
        loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
      },
    ],
  },
];
